var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(" 账单核销分布 ")]),(_vm.options)?_c('div',{staticClass:"echart"},[_c('ja-init-chart',{attrs:{"options":_vm.options}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }